import React, { useEffect, useRef, useState } from 'react';
import { ImageUp, Trash } from 'lucide-react';
import { Button, Typography } from '@material-tailwind/react';

const ButtonImgUpload = ({ formCamp, setValue, reset, multi = false }) => {
  const [image, setImage] = useState('');
  const fileImgRef = useRef();

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file && !file.type.startsWith('image/')) {
        alert('Por favor, selecione uma imagem válida.');
        return;
      }
      setValue(formCamp, event.target.files);
      setImage(file.name); // Mostra a pré-visualização da imagem
    }
  };

  const handleFileChange = (event) => {
    if (fileImgRef.current) {
      fileImgRef.current.value = null;
      setImage('');
      setValue(formCamp, '');
    }
  };

  useEffect(() => {
    if (reset) {
      handleFileChange();
    }
  }, [reset]);

  return (
    <div className="flex flex-row  gap-4 w-[50%] flex-wrap">
      <Button
        variant="gradient"
        color="white"
        className="flex items-center gap-3 h-8 p-5 mr-auto"
        size="md"
        onClick={() => document.getElementById('image-upload').click()}
      >
        <ImageUp />
        Enviar IMG
      </Button>
      {image && (
        <Typography
          className="font-bold italic  underline cursor-pointer flex gap-2 hover:text-red-700"
          onClick={handleFileChange}
          color="red"
        >
          {multi ? 'Foto Adicionadas' : image}
          <Trash color="red" />
        </Typography>
      )}
      <input
        ref={fileImgRef}
        type="file"
        id="image-upload"
        accept="image/*"
        multiple={multi}
        style={{ display: 'none' }} // Oculta o input nativo
        onChange={handleImageUpload}
      />
    </div>
  );
};

export default ButtonImgUpload;
